export const greensparksBreakpoints = {
  compact: 0,
  phoneWide: 600,
  tablet: 900,
  desktop: 1200,
  wide: 1536,
  immersive: 1536,
};

export const greensparksDeviceTiers = {
  phone: "(max-width: 899px)",
  tablet: "(min-width: 900px) and (max-width: 1199px)",
  desktop: "(min-width: 1200px) and (max-width: 1535px)",
  wide: "(min-width: 1536px)",
  immersive: "(min-width: 1536px)",
};

export const greensparksMuiBreakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

export const greensparksLayout = {
  contentNarrow: "720px",
  contentReadable: "840px",
  contentWide: "1120px",
  contentFull: "1280px",
  touchTarget: "44px",
};

export const greensparksRadii = {
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "12px",
  xl: "16px",
};

export const greensparksBrand = {
  green: "#5fc954",
  greenDark: "#2f8f45",
  blue: "#2367c8",
  ink: "#152033",
  cloud: "#f4f7fb",
};
